var map = {
	"./angular.jpg": "818a",
	"./javascript.jpg": "9135",
	"./python.jpg": "713e",
	"./react.jpg": "7756",
	"./svelte.jpg": "58e2",
	"./typescript.jpg": "b56f",
	"./vue.jpg": "c99b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9db";